export class AttributeDescriptionDialogViewModel
{
    opened: boolean = false;

    name: string | null = null;
    description: string | null = null;


    show(attrName: string, attrDesc: string | null)
    {
        this.name = attrName;
        this.description = attrDesc;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.name = null;
        this.description = null;
    }
}